// tslint:disable:max-line-length

import React from 'react';

export const LogoYoutube = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M15.7,4.2c-0.2-0.7-0.7-1.2-1.4-1.4C13,2.4,8,2.4,8,2.4s-5,0-6.3,0.3C1.1,2.9,0.5,3.5,0.3,4.2C0,5.4,0,8,0,8 s0,2.6,0.3,3.8c0.2,0.7,0.7,1.2,1.4,1.4C3,13.6,8,13.6,8,13.6s5,0,6.3-0.3c0.7-0.2,1.2-0.7,1.4-1.4C16,10.6,16,8,16,8 S16,5.4,15.7,4.2z M6.4,10.4V5.6L10.6,8L6.4,10.4z" />
    </svg>
  );
};
